<template>
    <v-container class="background">
        <v-row align="center" justify="center" class="pt-5 mt-5">
            <v-col xs="12" sm="8" md="6">
                <v-stepper
                    v-model="step"
                    alt-labels
                >
                    <v-stepper-header>
                        <v-stepper-step
                            :complete="step > 1"
                            step="1"
                        >
                            Create Account
                        </v-stepper-step>

                        <v-divider />

                        <v-stepper-step
                            :complete="step > 2"
                            step="2"
                        >
                            Verify Email
                        </v-stepper-step>

                        <v-divider />

                        <v-stepper-step
                            step="3"
                        >
                            Choose Handle
                        </v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-container fluid>
                            <router-view />
                        </v-container>
                    </v-stepper-items>
                </v-stepper>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data () {
        return {
            step: 1
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler () {
                switch (this.$route.name) {
                case 'createAccount':
                    this.step = 1
                    break
                case 'verifyEmail':
                    this.step = 2
                    break
                case 'chooseHandle':
                    this.step = 3
                    break
                }
            }
        }
    }
}
</script>

<style scoped>
.background {
    background-image: url("../../assets/celebration.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
.blur {
    backdrop-filter: blur(8px);
}
</style>
